export default "__VITE_ASSET__DKxlEFoo__"